import { api } from "../../authClient";

// An HOD uses these pages in read-only supervision mode. Their requests go to the teacher-scoped endpoints, which
// return only the classes of the departments they head (the /admin/... endpoints cover the whole school).
export const isHodReader = () => localStorage.getItem("user_role") === "hod";

const scoped = (url) => (isHodReader() && typeof url === "string" ? url.replace("/admin/student-reports/", "/teacher/student-reports/") : url);

export const reportsApi = {
    get: (url, ...rest) => api.get(scoped(url), ...rest),
    post: (url, ...rest) => api.post(scoped(url), ...rest),
    put: (url, ...rest) => api.put(scoped(url), ...rest),
    patch: (url, ...rest) => api.patch(scoped(url), ...rest),
    delete: (url, ...rest) => api.delete(scoped(url), ...rest),
};
